<template>
  <div class="dialog-wrap">
    <el-dialog
      title="内容选择"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      :width="dialogWidth"
    >
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item label="内容分类">
          <el-select
            v-model="query.category_id"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in categorylist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="内容名称"
          prop="name"
        >
          <el-input
            v-model="query.name"
            placeholder="请输入内容名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="状态"
          prop="status"
        >
          <el-select
            style="width: 100px"
            v-model="query.status"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="mini"
            @click="handleSearch"
          >搜索</el-button>
          <el-button
            class="submit"
            size="mini"
            @click="handleFormReset('searchForm')"
          >重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        class="result"
        ref="multipleTable"
        :data="results"
        tooltip-effect="dark"
        size="mini"
        highlight-current-row
      >
        <!--    <el-table-column
          prop="id"
          label="ID"
          width="80"
          align="center"
        >
        </el-table-column> -->
        <el-table-column
          label="主图"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            <img
              :src="scope.row.picture_url"
              style="height:50px;"
              alt=""
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            <div style="text-align:left;">
              {{scope.row.name || scope.row.title}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="scope.row.status?'success':'info'"
            >{{scope.row.status?'已发布':'未发布'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="分类"
          min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            {{formateCategory_id(scope.row.category_id)}}
          </template>
        </el-table-column>
        <el-table-column
          label="价格"
          prop="price"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="参考价格"
          prop="market_price"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="购买人数"
          prop="user_count"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="创建时间"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{$moment(scope.row.create_time).format('YYYY.MM.DD')}}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="70"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              :disabled="filter_ids.includes(scope.row.id)"
              @click="handleSubmit(scope.row)"
              :class="{'tools-button':isSize}"
            >选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          background
          small
          layout="total, prev, pager, next, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { courseList, courseCategoryList, courselistCount } from "@/api/course"
import { examList } from "@/api/exam"
import { readList, readcategorylist } from "@/api/read"
import { materialList, materialcategorylist } from "@/api/material"
import { articleList, articleCategoryList } from "@/api/article"

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    ref_type: {
      type: Number,
      default: 0
    },
    filter_ids: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      query: {
        id: '',
        name: "",
        status: "1",
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        is_all: 1,
      },
      value: '',
      pageTotal: 10,
      filter: {
        status: [
          { label: "全部", value: "" },
          { label: "已发布", value: "1" },
          { label: "未发布", value: "0" }
        ],
      },
      results: [],
      selection: {},
      dialogWidth: document.body.clientWidth < 820 ? '95%' : '980px',
      isSize: document.body.clientWidth < 820,
      categorylist: [],
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;

      if (val) {
        this.fetchGoodList();
      }
    }
  },
  methods: {
    fetchGoodList() {
      if (this.ref_type == 1) {
        courseList(this.query).then(res => {
          this.results = res.list

          courseCategoryList({ isPaging: 0 }).then(res => {
            this.categorylist = res.list
          })
          courselistCount().then(res => {
            this.pageTotal = res.count[0].total;
          })
        })
      }
      if (this.ref_type == 2) {
        examList(this.query).then(res => {
          this.results = res.list
          this.pageTotal = res.count
          this.categorylist = []
        })
      }
      if (this.ref_type == 3) {
        readList(this.query).then(res => {
          this.results = res.list
          this.pageTotal = res.count
          readcategorylist({ isPaging: 0 }).then(res => {
            this.categorylist = res.list
          })
        })
      }
      if (this.ref_type == 4) {
        materialList(this.query).then(res => {
          this.results = res.list
          this.pageTotal = res.count
          materialcategorylist({ isPaging: 0 }).then(res => {
            this.categorylist = res.list
          })
        })
      }
      if (this.ref_type == 5) {
        articleList(this.query).then(res => {
          this.results = res.list
          this.pageTotal = res.count
          articleCategoryList({ isPaging: 0 }).then(res => {
            this.categorylist = res.list
          })
        })
      }
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchGoodList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchGoodList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchGoodList();
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        '1': '正常',
        '0': '禁用'
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    handleSubmit(val) {
      val.name = val.name || val.title
      this.$emit("submit", val);
      this.handleClose();
    },
    handleClose() {
      // 检索条件重置
      this.query = {
        id: '',
        name: "",
        status: "",
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1
      };
      this.$emit("close");
    },
    formateCategory_id(id) {
      if (this.categorylist.length) {
        if (id) {
          return this.categorylist.find((v) => {
            return v.id == id;
          }).name;
        } else {
          return "无";
        }
      } else {
        return "无";
      }

    },
  }
};
</script>

<style lang="less" scoped>
.dialog-wrap {
  .search-wrap {
    margin-bottom: -8px;

    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
      margin-bottom: 10px;
    }
  }
  .result {
    margin-top: 10px;
  }
  .footer {
    margin-top: 10px;
  }
}
.tools-button {
  width: 45px;
  text-align: center;
  font-size: 10px;
  padding: 0;
  height: 20px;
}
</style>
